import { createSelector } from 'reselect';
import { CONVERSATIONS_ACCESS } from 'conversations-internal-schema/constants/Scopes';
import { getScopes } from './getScopes';
export const hasConversationsAccess = createSelector(getScopes, scopes => scopes.includes(CONVERSATIONS_ACCESS));